// extracted by mini-css-extract-plugin
export default {"link":"homepagefooter_link__pNxsQ","bg":"homepagefooter_bg__q9Rbw"};